import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WidgetPreferenceService {
  private widgets = [
    { id: 'widget1', name: 'Widget 1', component: 'Widget1Component' },
    { id: 'widget2', name: 'Widget 2', component: 'Widget2Component' },
    { id: 'widget3', name: 'Widget 3', component: 'Widget3Component' },
  ];

  private userPreferences: string[] = ['widget1', 'widget2', 'widget3'];

  getAvailableWidgets() {
    return this.widgets;
  }

  getUserPreferences() {
    return this.userPreferences;
  }

  setUserPreferences(preferences: string[]) {
    this.userPreferences = preferences;
  }
}
